import { createApp } from 'vue';
import App from './App.vue';
import 'normalize.css';
import '@/style/main.scss';

createApp(App).mount('#app')
